import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, useMediaQuery, useTheme
} from "@material-ui/core";

import Cropper, {} from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { observer } from "mobx-react";
import {RotateCcw, RotateCw} from "react-feather"
import { dataURItoFile } from "../libs";
import { Centered, CircularProgress } from "./libs";
import { useTranslation } from "react-i18next";


interface Props {
    open: boolean,
    close: () => void;
    image?: File,
    uploadImage: (file: File) => Promise<void>,
    minBoxSizes?: {
        height?: number,
        width?: number
    },
    aspectRation: ImageAspectRatio,
    name?: string;
}


export enum ImageAspectRatio{
    rectangle_2_2 = 1,
    rectangle_3_2 = 3/2
}


const ImageCropperForm = (props: Props) => {
    const {t} = useTranslation(["general"]);
    const [imageSrc, setImageSrc] = useState("#");
    const [isLoading, setIsLoading] = useState(true);
    const [cropper, setCropper] = useState<Cropper>();
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const name = props.name;

    useEffect(() => {
        if (!props.image) {
            setIsLoading(true);
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImageSrc(reader.result as string);
            setIsLoading(false);
        };
        reader.readAsDataURL(props.image);
    }, [props.image]);



    const handleSubmit = async () => {
        if (typeof cropper !== "undefined") {
            props.close();
            let fileName;
            if (props.name) fileName = props.name;
            else fileName =`${props.image.name.split(".")[0]}.jpeg`;
            const file = dataURItoFile(
                cropper.getCroppedCanvas({
                    fillColor: '#ffffff',
                    // maxWidth: 1000,
                }).toDataURL('image/jpeg'),
                fileName,

            );
            await props.uploadImage(file);
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={props.close}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("general:workWithImage")}
            </DialogTitle>

            <DialogContent>
                {!isLoading && <>
                    <Cropper
                        src={imageSrc}
                        initialAspectRatio={props.aspectRation}
                        aspectRatio={props.aspectRation}
                        minCropBoxHeight={200}
                        minCropBoxWidth={200}
                        guides={true}
                        rotatable={true}
                        style={{ height: 500 }}
                        crop={() => {}}
                        onInitialized={(newCropper) => {
                            setCropper(newCropper);
                        }}
                    />
                    <Centered>
                        <Button onClick={() => {
                            cropper.rotate(-90)
                        }} color="primary">
                            <RotateCcw/>
                        </Button>
                        <Button onClick={() => {
                            cropper.rotate(90)
                        }} color="primary">
                            <RotateCw/>
                        </Button>
                    </Centered>
                </>
                }


                {isLoading && <div
                    style={{
                        minHeight: "400px",
                        minWidth: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <CircularProgress
                        m={2}
                        color="secondary"
                    />
                </div>}
            </DialogContent>

            <DialogActions>
                <Button onClick={() => {
                    props.close();
                }} color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="primary"
                    onClick={handleSubmit}
                >
                    {t("general:save")}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default observer(ImageCropperForm);
